import {
    Stethoscope,
    Sparkles,
    Activity,
    Syringe,
    Plus,
    Crown,
    Layers,
    Smile,
    Star,
    Heart,
    Shield,
    Ruler,
    Baby,
    Siren,
    HeartHandshake,
    ListChecks,
    Zap,
    MessageCircle,
    ShieldCheck,
    LayoutGrid,
} from "lucide-react";

export const CLINIC = {
    name: "Smile Dental Clinic",
    addressLines: [
        "207, Picnic Garden Rd,",
        "Kata Pukur, Kasba,",
        "Kolkata, West Bengal 700039",
    ],
    phoneDisplay: "+91 94343 33353",
    phoneTel: "+91943433353",
    mapsUrl: "https://maps.app.goo.gl/m8DxtSXee3G6PE6e7",
    mapEmbed:
        "https://www.google.com/maps?q=207%20Picnic%20Garden%20Rd%2C%20Kata%20Pukur%2C%20Kasba%2C%20Kolkata%2C%20West%20Bengal%20700039&output=embed",
};

export const NAV_LINKS = [
    { label: "Home", href: "#home" },
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Why Choose Us", href: "#why-us" },
    { label: "Reviews", href: "#reviews" },
    { label: "Contact", href: "#contact" },
];

export const SERVICES = [
    { icon: Stethoscope, title: "General Dental Consultation", desc: "A thorough examination and clear guidance on your oral health." },
    { icon: Sparkles, title: "Teeth Cleaning & Polishing", desc: "Gentle scaling and polishing for a fresh, healthy smile." },
    { icon: Activity, title: "Root Canal Treatment", desc: "Careful treatment to relieve pain and save your natural tooth." },
    { icon: Syringe, title: "Tooth Extraction", desc: "Safe, comfortable removal of damaged or problematic teeth." },
    { icon: Plus, title: "Dental Fillings", desc: "Tooth-coloured fillings that restore strength and shape." },
    { icon: Crown, title: "Dental Crowns & Bridges", desc: "Durable restorations to rebuild damaged or missing teeth." },
    { icon: Layers, title: "Dental Implants", desc: "A stable, long-term replacement option for missing teeth." },
    { icon: Smile, title: "Dentures", desc: "Comfortable, natural-looking full and partial dentures." },
    { icon: Star, title: "Teeth Whitening", desc: "Professional whitening for a visibly brighter smile." },
    { icon: Heart, title: "Cosmetic Dentistry", desc: "Treatments designed to refine the look of your smile." },
    { icon: Shield, title: "Gum Care", desc: "Focused care to keep your gums healthy and strong." },
    { icon: Ruler, title: "Braces & Teeth Alignment", desc: "Guided alignment for a straighter, confident smile." },
    { icon: Baby, title: "Pediatric Dental Care", desc: "Gentle, friendly dental care designed for children." },
    { icon: Siren, title: "Emergency Dental Consultation", desc: "Prompt attention for dental pain and urgent concerns." },
];

export const WHY_US = [
    { icon: HeartHandshake, title: "Personalized Care", desc: "Every treatment plan is shaped around your needs, comfort and goals." },
    { icon: LayoutGrid, title: "Comprehensive Dental Services", desc: "From preventive care to restorative and cosmetic treatment, all in one place." },
    { icon: Smile, title: "Patient-Friendly Experience", desc: "A calm, welcoming visit designed to put you at ease." },
    { icon: Zap, title: "Modern Treatment Approach", desc: "A careful, up-to-date approach to everyday dental care." },
    { icon: MessageCircle, title: "Clear Consultation", desc: "Honest explanations and transparent guidance before any treatment." },
    { icon: ShieldCheck, title: "Focus on Long-Term Oral Health", desc: "Care that looks beyond today to protect your smile for years." },
];

export const ABOUT_POINTS = [
    "Personalized consultation",
    "Preventive dental care",
    "Restorative dental solutions",
    "Comfortable patient experience",
    "Clear treatment guidance",
];

export const APPOINTMENT_SERVICES = [
    "General Consultation",
    "Teeth Cleaning & Polishing",
    "Root Canal Treatment",
    "Tooth Extraction",
    "Dental Filling",
    "Dental Crown / Bridge",
    "Dental Implant",
    "Dentures",
    "Teeth Whitening",
    "Cosmetic Dentistry",
    "Gum Treatment",
    "Braces / Teeth Alignment",
    "Pediatric Dental Care",
    "Emergency Consultation",
    "Other",
];

export const TIME_SLOTS = (() => {
    const slots = [];
    for (let h = 9; h <= 20; h++) {
        for (const m of ["00", "30"]) {
            if (h === 20 && m === "30") break;
            const hour12 = ((h + 11) % 12) + 1;
            const ampm = h < 12 ? "AM" : "PM";
            slots.push(`${String(hour12).padStart(2, "0")}:${m} ${ampm}`);
        }
    }
    return slots;
})();

export const FAQS = [
    {
        q: "How can I book a dental appointment?",
        a: "Fill in the appointment form on this page or call the clinic at +91 94343 33353. Your booking request is confirmed directly with the clinic.",
    },
    {
        q: "What dental services are available?",
        a: "The clinic offers consultations, teeth cleaning, root canal treatment, fillings, crowns and bridges, implants, dentures, whitening, cosmetic dentistry, gum care, braces, pediatric care and emergency consultations.",
    },
    {
        q: "Can I book an appointment through WhatsApp?",
        a: "Yes. Booking requests made through the appointment form open in WhatsApp, where you can review and send your details to the clinic for confirmation.",
    },
    {
        q: "Do I need an appointment before visiting?",
        a: "An appointment is recommended so the clinic can reserve dedicated time for you. For urgent dental concerns, call the clinic directly.",
    },
    {
        q: "What should I bring for my first dental consultation?",
        a: "Bring any previous dental records or X-rays you may have, a list of current medications, and a note of the concerns you would like to discuss.",
    },
    {
        q: "How can I get directions to the clinic?",
        a: "Use the Get Directions button in the contact section. The clinic is located at 207, Picnic Garden Rd, Kata Pukur, Kasba, Kolkata 700039.",
    },
];

export const MARQUEE_ITEMS = [
    "Preventive Dentistry",
    "Root Canal Treatment",
    "Dental Implants",
    "Teeth Whitening",
    "Cosmetic Dentistry",
    "Pediatric Care",
    "Gum Care",
    "Emergency Care",
];

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1629909613654-28e377c37b09?q=80&w=1200&auto=format&fit=crop",
    about: "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?q=80&w=1200&auto=format&fit=crop",
    featured: "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?q=80&w=1400&auto=format&fit=crop",
};
